export default __webpack_public_path__ + "static/media/mobile.mysz.56732caa.webp";